export const viewDirectory = (toolMessage: any, results: any) => {
    const textContent = "Here are the contents within the directory requested:\n"

    const content = [{
        type: 'text',
        text: `${textContent}${results.contents}`
    }];
    const truncatedContent = [{
        type: 'text',
        text: `${textContent}:\n\`\`\`\n<Truncated for brevity>\n\`\`\``
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
